import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppStateFacade } from '@app-state';
import { IQueue } from '@models';
import { ODataQueryOptions } from '@services/generics/odata.query';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

import { map } from 'rxjs/operators';

@Injectable()
export class QueueDefinitionService extends ODataService<IQueue, number> {
    protected _endpoint: string;
    constructor(
        http: HttpClient,
        { authConfig }: AppStateFacade,
    ) {
        super(http, MapperService.queueMap);
        this._endpoint = `${authConfig.odataBaseUrl}/QueueDefinitions`;
    }

    public getQueueNameById(queueDefinitionId: number) {
        return this.getInstance(queueDefinitionId)
            .pipe(map(res => res.name));
    }

    public getQueueNameAndSlaById(queueDefinitionId: number) {
        return this.getInstance(queueDefinitionId)
            .pipe(map(res => ({name: res.name, slaMinutes: res.slaMinutes})));
    }

    public getReportsUrl(queueDefinitionId: number, queryOptions: ODataQueryOptions) {
        return `${this._endpoint}(${queueDefinitionId})/UiPathODataSvc.Reports${this.getQueryString(queryOptions)}`;
    }

    public getDownloadSchemaJsonLink(queueDefinitionId: number, schemaType: string) {
        return `${this._endpoint}(${queueDefinitionId})/UiPathODataSvc.GetJsonSchemaDefinition(jsonSchemaType='${schemaType}')`;
    }

    public suggest = (searchTerm: string = '', fetchSize = 20, skip: number = 0) => {
        const queryOptions: ODataQueryOptions = {
            select: ['Id', 'Name'],
            orderBy: ['Name'],
            top: fetchSize,
            skip,
            filter: {
                Name: {
                    startswith: searchTerm,
                },
            },
        };

        return this._suggest(queryOptions);
    }

    public queueTriggerSuggest = (triggerId: number, searchTerm: string = '', fetchSize = 20, skip: number = 0) => {
        const queryOptions: ODataQueryOptions = {
            select: ['Id', 'Name'],
            orderBy: ['Name'],
            top: fetchSize,
            skip,
            filter: {
                and: [
                    {
                        Name: {
                            startswith: searchTerm,
                        },
                    },
                    {
                        or: [
                            {
                                'ProcessScheduleId': null,
                            },
                            {
                                'ProcessScheduleId': isNaN(triggerId) ? -1 : triggerId,
                            },
                        ],
                    }],
            },
        };

        return this._suggest(queryOptions);
    }

    private _suggest(queryOptions: ODataQueryOptions) {
        return this.get(queryOptions, this._endpoint)
            .pipe(
                map(
                    ({ data, total }) =>
                        ({
                            total,
                            data: data.map(queue => ({
                                id: queue.id,
                                text: queue.name,
                            })),
                        }),
                ),
            );
    }
}
